import React from "react";
import EnlaceAModal, { ContenidoDeEnlace } from "./EnlaceAModal";
import { Link } from "react-router-dom";
import Default from "./Default";
import { getAtributo } from "../../../context/FuncionesContext";

const EnlaceOpcional = ({
  data,
  cab,
  id,
  campokey,
  hijos,
  id_elemento,
  qsBody,
}) => {
  const enlace_id_a = data[cab.id_a + "_enlace_id_a"] ?? cab.enlace_id_a;
  const boton_texto = getAtributo("boton_texto", data, cab)

  if (!enlace_id_a) {
    return (
      <Default
        key={cab.id_a}
        data={data}
        cab={cab}
        hijos={hijos}
        campokey={campokey}
      />
    );
  }

  const nombre = (() => {
    if (cab.nombre_alias) {
      return data[cab.nombre_alias];
    }
    return cab.nombre;
  })();
  let paramObj = {};
  const parametros = (() => {
    let parametros_keys = [];
    let parametros_valores = [];

    if (cab.enlace_parametros_nombres_alias) {
      parametros_keys = cab.enlace_parametros_nombres_alias
        .split(",")
        .map((alias) => data[alias])
        .filter((e) => e);
    }
    if (!cab.enlace_parametros_nombres_alias) {
      parametros_keys = cab.enlace_parametros_nombres
        ?.split(",")
        .filter((e) => e);
    }
    if (cab.enlace_parametros_alias) {
      parametros_valores = cab.enlace_parametros_alias
        .split(",")
        .map((alias) => data[alias])
        .filter((e) => e);
    }
    if (!cab.enlace_parametros_alias) {
      // console.log("enlace_para",cab.enlace_parametros)
      parametros_valores = cab.enlace_parametros?.split(",").filter((e) => e);
    }

    let parametros = "?";

    // eslint-disable-next-line no-unused-expressions
    parametros_keys?.forEach((key, i) => {
      if (parametros_valores[i]) {
        parametros = parametros.concat(`&${key}=${parametros_valores[i]}`);
        paramObj[key] = parametros_valores[i];
      }
    });
    return parametros;
  })();

  if (cab.target === "modal") {
    // pasar componente que envia a modal a un componente nuevo para evitar el Context
    return (
      <EnlaceAModal
        nombre={nombre}
        paramObj={paramObj}
        cab={cab}
        data={data}
        id_elemento={id_elemento}
        qsBody={qsBody}
        enlace_id_a={enlace_id_a}
        campokey={campokey}
      />
    );
  }

  if (cab.target === "_blank") {
    return (
      <div
        id={id_elemento}
        className={cab.className}
        style={{ display: "flex" }}
        title={data[cab.id_a + "_tooltip_texto"] ?? cab.tooltip_texto}
      >
        {" "}
        {nombre ? (
          <div className="vista_label" style={{ fontWeight: "bold" }}>
            {nombre}:{" "}
          </div>
        ) : (
          <></>
        )}
        <a
          className="enlace"
          target="_blank"
          href={
            process.env.PUBLIC_URL +
            "/#" +
            cab.enlace +
            enlace_id_a +
            parametros
          }
          rel="noopener noreferrer"
        >
          <div
            style={{
              textAlign: "center",
            }}
          >
            <ContenidoDeEnlace
              texto={
                data[campokey] ?? boton_texto
              }
              imagen={cab.imagen_url}
            />
            {hijos}
          </div>
        </a>
      </div>
    );
  }

  return (
    <div id={id_elemento} style={{ display: "flex" }} title={cab.tooltip_texto}>
      {nombre ? (
        <div className={`vista_label`} style={{ fontWeight: "bold" }}>
          {nombre}:{" "}
        </div>
      ) : (
        <></>
      )}
      <div className={`vista_dato  ${cab.className}`}>
        <Link
          to={{
            pathname: cab.enlace + enlace_id_a,
            search: parametros,
          }}
        >
          <ContenidoDeEnlace
            texto={
              data[campokey] ?? boton_texto
            }
            imagen={cab.imagen_url}
          />
        </Link>
      </div>
    </div>
  );
};
export default EnlaceOpcional;
